import { Injectable } from '@angular/core';
import { CanActivate, UrlTree, Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { ENavigationErrorType } from '../model/enum/navigation-error-type';
import { ENavigationRoute } from '../model/enum/navigation-route';
import { CoreData } from './core-data/core-data';

@Injectable()
export class LoginGuard implements CanActivate {
    constructor(private router: Router,
        private coreData: CoreData) { }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | UrlTree {

        if (!this.coreData.IsLoggedIn) {
            return this.router.createUrlTree([ENavigationRoute.Error, { type: ENavigationErrorType.UnAuthenticated }]);
        }

        const url = route.url[0] === undefined ? ENavigationRoute.Order : route.url[0].path;
        return (this.coreData.IsLoggedIn && this.hasPermission(url))
            || this.router.createUrlTree([ENavigationRoute.Error, { type: ENavigationErrorType.UnAuthorized }]);
    }

    hasPermission(url: string) {
        switch (url) {
            case ENavigationRoute.Config:
            case ENavigationRoute.Calendar:
            case ENavigationRoute.Order:
            case ENavigationRoute.Export:
            case ENavigationRoute.Chart:
            case ENavigationRoute.Notifications:
                if (this.coreData.User) {
                    return true;
                }
                break;
        }
        return false;
    }
}

